import { render } from "./warn2.vue?vue&type=template&id=4acdb11d&scoped=true"
import script from "./warn2.vue?vue&type=script&lang=js"
export * from "./warn2.vue?vue&type=script&lang=js"

import "./warn2.vue?vue&type=style&index=0&id=4acdb11d&lang=scss&scoped=true"
import "./warn2.vue?vue&type=style&index=1&id=4acdb11d&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acdb11d"]])

export default __exports__